// 数据缺省值
export const DEFAULT_VALUE = "--";
export const LOG_DATE_FORMAT_START = "YYYY-MM-DDT00:00:00";
export const LOG_DATE_FORMAT_END = "YYYY-MM-DDT23:59:59";

/**
 * element-plus 响应式布局配置
 */
export const responseConfig = {
  xs: 24,
  sm: 24,
  md: 12,
  lg: 8,
  xl: 6
}
